import { render, staticRenderFns } from "./FormularioGerenteComercial.vue?vue&type=template&id=161d21a6&lang=pug"
import script from "./FormularioGerenteComercial.vue?vue&type=script&lang=js"
export * from "./FormularioGerenteComercial.vue?vue&type=script&lang=js"
import style0 from "./FormularioGerenteComercial.vue?vue&type=style&index=0&id=161d21a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports